<template>
  <span>
    {{ showDetails }}
  </span>
</template>
<script>
import gql from "fraql";
import { get } from "lodash-es";
export default {
  name: "AppShowEventDetailsLine",
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    showDetails() {
      function showReferenceCode(event) {
        if (event.externalReferenceCode) {
          return ` | ${event.externalReferenceCode}`;
        }
        return event.referenceCodeForDisplay
          ? ` | ${event.referenceCodeForDisplay}`
          : "";
      }

      return [
        ` - ${this.$dayjs.date(this.event.startDate)}`,
        showReferenceCode(this.event),
        get(this.event.organiser, "name", null),
        this.event.hostOrganisation
          ? `| ${get(this.event.hostOrganisation, "name", null)}`
          : null
      ]
        .filter(Boolean)
        .join(" ");
    }
  },

  fragments: {
    event: gql`
      fragment _ on Event {
        startDate
        externalReferenceCode
        referenceCodeForDisplay
        organiser {
          id
          name
        }
        hostOrganisation {
          id
          name
        }
      }
    `
  }
};
</script>
